import { useQuery } from "@apollo/client";
import ConfigShowQuery from "../graphql/queries/ConfigShowQuery.graphql";
import ConfigEditQuery from "../graphql/queries/ConfigEditQuery.graphql";

export function useConfigShowQuery(id: string | null, skip = false) {
  return useQuery(ConfigShowQuery, {
    variables: { id },
    skip: skip || !id,
  });
}

export function useConfigEditQuery(id: string | null, skip = false) {
  return useQuery(ConfigEditQuery, {
    variables: { id },
    skip: skip || !id,
  });
}
